import React from "react";
import ServiceGroupChecklistDownComponent, {
  ServiceLocation,
} from "../../../../../../components/InputValues/ServiceGroupChecklistDownComponent";
import { ItemType } from "../../../../../../components/InputValues/VerticalGroupDropDownComponent";
import PopUpBaseComponent from "../../../../../../components/PopUps/PopUpBaseComponent";
import VerticalServiceGroup from "../../../../../../services/interfaces/VerticalServiceGroup";
import {
  ContentContainer,
  Description,
} from "./OrderOfStepsEditServicePopUp.styles";

interface OrderOfStepsEditServicePopUpProps {
  isOpen: boolean;
  verticalServiceGroups: VerticalServiceGroup[];
  isLoading: boolean;
  onClose: () => void;
  cancelOnClick: () => void;
  onConfirm: (selectedTypes: ServiceLocation[]) => void;
}

const OrderOfStepsEditServicePopUp: React.FC<
  OrderOfStepsEditServicePopUpProps
> = ({
  isOpen,
  onClose,
  isLoading,
  verticalServiceGroups,
  cancelOnClick,
  onConfirm,
}) => {
  const [selectedGroupByStep, setSelectedGroupByStep] = React.useState<
    ItemType[]
  >([]);

  const [selectedLocations, setSelectedLocations] = React.useState<
    ServiceLocation[]
  >([]);

  const confirmOnClick = () => {
    onConfirm([...selectedLocations]);
    setSelectedLocations([]);
  };

  return (
    <PopUpBaseComponent
      isOpen={isOpen}
      closeOnClick={onClose}
      cancelOnClick={cancelOnClick}
      confirmOnClick={() => confirmOnClick()}
      isLoading={isLoading}
      enableConfirmButton={selectedLocations.length > 0}
      titte="Editar serviço"
      positiveButtonText="Reprogramar etapas"
      negativeButtonText="Manter Etapas"
    >
      <ContentContainer>
        <Description>
          Essa alteração impacta nas etapas seguintes do serviço. Selecione
          quais etapas você gostaria de reprogramar.
        </Description>
        <ServiceGroupChecklistDownComponent
          values={verticalServiceGroups}
          key="ServiceGroupChecklistDownComponent"
          onSelectedValueChanged={(items) => {
            setSelectedLocations(items);
          }}
        />
      </ContentContainer>
    </PopUpBaseComponent>
  );
};

export default OrderOfStepsEditServicePopUp;
